import Vue from 'vue'
import Vuex from 'vuex'
import {Loading} from 'element-ui';
import createPersistedState from 'vuex-persistedstate';
import CryptoJS from 'crypto-js';
import cart from './cart';
import { clearCookieAuthState, hasCookieSessionMarker, cookieAuthEnabled } from '@/http/authMode';

Vue.use(Vuex)

let isLogin = cookieAuthEnabled ? hasCookieSessionMarker() : !!localStorage.getItem('token')
let userInfo = localStorage.getItem('users')?JSON.parse(localStorage.getItem('users')) : {}

export default new Vuex.Store({
    state: {
        sessionKey: null,
        isLogin,
        showLogin: false,
        userInfo,
        userPreferences: {
            paginationSize: 10, // 默认分页大小为10
            paginationSizes: [10, 20, 50, 100] // 默认分页候选项
        }
    },
    getters: {
        isLogin: state => state.isLogin,
        showLogin: state => state.showLogin,
    },
    mutations: {
        setSessionKey(state, key) {
            state.sessionKey = key;
        },
        vuexShowLogin(state, type) {
            state.showLogin = type
        },
        vuexSetLogin(state, type) {
            state.isLogin = type
            console.log('vuex: ', type)
        },
        vuexSetUser(state, userInfo) {
            state.userInfo = userInfo
        },
        vuexSignOut(state) {
            console.log('注销登录')
            let loadingInstance = Loading.service();
            state.isLogin = false
            state.userInfo = {}
            if (cookieAuthEnabled) {
                clearCookieAuthState()
                localStorage.removeItem('token')
                localStorage.removeItem('users')
            } else {
                localStorage.clear()
            }
            loadingInstance.close();
        },
        // 新增用户偏好设置 mutation
        updateUserPreference(state, payload) {
            state.userPreferences = {
                ...state.userPreferences,
                ...payload
            }
        }
    },
    actions: {
        generateSessionKey({ commit }) {
            const key = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex)
            commit('setSessionKey', key);
        },
    },
    modules: {
        cart,
    },
    plugins: [createPersistedState({
        storage: window.localStorage,
        paths: ['cart', 'sessionKey', 'userPreferences'] // 将userPreferences加入持久化
    })]
})
